import { motion } from "framer-motion";

const STATS = [
  ["0", "Accounts created"],
  ["0", "Trackers installed"],
  ["0", "Bytes of identity sold"],
];

export default function Privacy() {
  return (
    <section
      id="privacy"
      data-testid="privacy-section"
      className="border-b border-[var(--sp-line)]"
    >
      <div className="mx-auto max-w-[1500px] px-5 py-20 sm:px-8 lg:py-28">
        <div className="lg:grid lg:grid-cols-[1.4fr_0.85fr] lg:items-center lg:gap-16">
          <div>
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="mb-8 flex items-center gap-3 font-mono2 text-xs uppercase tracking-[0.28em] text-[var(--sun)]"
        >
          <span className="h-px w-10 bg-[var(--sun)]" />
          Privacy Guarantee // 06
        </motion.p>
        <motion.blockquote
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
          data-testid="privacy-guarantee-card"
          className="max-w-5xl font-display text-3xl font-black uppercase leading-[0.95] tracking-tight text-[var(--sp-fg)] sm:text-5xl lg:text-6xl"
        >
          You do this all without an account.{" "}
          <span className="text-[var(--sun)]">Your privacy is preserved.</span>
        </motion.blockquote>
        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="mt-6 max-w-xl text-base leading-relaxed text-[var(--sp-muted)]"
        >
          No sign-up. No cookies following you across the web. No identity attached to a comfort
          query. Ask, get your shade, and disappear — that is the entire transaction.
        </motion.p>
          </div>
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.8, delay: 0.15 }}
            className="mt-10 flex justify-center lg:mt-0"
          >
            <span className="app-screen w-full max-w-[260px]">
              <img
                src="/app-shots/09-privacy-offline.jpeg"
                alt="ShadyParking in-app privacy policy, explaining that your data stays on your device"
                loading="lazy"
                data-testid="privacy-app-screen"
                className="aspect-[4/5] w-full object-contain"
              />
            </span>
          </motion.div>
        </div>
        <div className="mt-12 grid grid-cols-1 border border-[var(--sp-line)] sm:grid-cols-3 sm:divide-x sm:divide-[var(--sp-line)]">
          {STATS.map(([n, label], i) => (
            <motion.div
              key={label}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: i * 0.1 }}
              data-testid={`privacy-stat-${i}`}
              className="px-8 py-8 text-center sm:text-left"
            >
              <p className="font-display text-6xl font-black leading-none text-[var(--sun)] lg:text-7xl">{n}</p>
              <p className="mt-2 font-mono2 text-[10px] uppercase tracking-[0.14em] text-[var(--sp-muted)]">
                {label}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
